// extracted by mini-css-extract-plugin
export default {"logo":"QqMWn7nb53C2RjovH1To"};